export const screens = {
  mobile: "481px",
  microtab: "541px",
  minitab: "769px",
  tab: "993px",
  lgTab: "1025px",
  desktop: "1281px",
  lgDesktop: "1367px",
};
